import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
// import { addCustomer } from 'slice/customerSlice';
import { postRequest } from 'apis/ApiInstence';

const AddCustomer = () => {
    const [formData, setFormData] = useState({
        name: '',
        mail: '',
        mobile: '',
        city: '',
        message: '',
        enquiry_type: 'construction' || 'complaint' || 'other'
    });

    // const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.product);
    const nevigate = useNavigate()

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));

    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // const formDataToSend = new FormData();
        // for (const key in formData) {
        //     formDataToSend.append(key, formData[key]);
        // }
        try {
            // dispatch(addCustomer(formData))
            const postCustomer = postRequest('contactus', formData);
            if (postCustomer) {
                toast('Customer added successfully!')
                nevigate('/customer')
                setFormData({
                    name: '',
                    image: null,
                })
            }
            else {
                toast('Failed to add customer. Please try again.')
            }
        } catch (error) {
            console.error('There was a problem adding the product:', error.message);
        }
    };

    return (
        <>
            <div className='container-fluid mt-5d'>
                <div className='mainheadig mx-4'>
                    <h4 className="text-white font-weight-bold">Add Contact Us Enquiry</h4>
            </div>
                <form onSubmit={handleSubmit}>
                    <div className='customer_data'>
                        <div className='col-sm-6 mt-2'>
                            <label htmlFor='productName'>Name</label>
                            <input placeholder='Enter Customer name' type='text' id='productName' name='name' defaultValue={formData.name} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-6 mt-2'>
                            <label htmlFor='productName'>mail</label>
                            <input type='text' id='productName' placeholder='Enter Customer Email' name='mail' defaultValue={formData.mail} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-6 mt-2'>
                            <label htmlFor='productName'>Mobile</label>
                            <input type='text' id='productName' placeholder='Enter Customer Mobile' name='mobile' defaultValue={formData.mobile} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-6 mt-2'>
                            <label htmlFor='productName'>City</label>
                            <input type='text' id='productName' name='city' placeholder='Enter Customer city' defaultValue={formData.city} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-6 mt-2'>
                            <label htmlFor='productName'>Enquiry Type</label>
                            <select id='productName' name='enquiry_type' defaultValue={formData.enquiry_type} className='form-control' onChange={handleChange}>
                                <option value='construction'>Construction</option>
                                <option value='complaint'>Complaint</option>
                                <option value='other'>Other</option>
                            </select>
                        </div>
                        <div className='col-sm-6 mt-2'>
                            <label htmlFor='productName'>Message</label>
                            <textarea type='text' id='productName' name='message' placeholder='Enter Customer message' defaultValue={formData.message} className='form-control' onChange={handleChange} />
                        </div>
                        
                    </div>
                    <div className='mt-4 text-right mx-4'>
                        <button className='btn addbtn' disabled={loading}>Add Customer</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default AddCustomer